import React from 'react';
import { Avatar, CardAvatar, Tag, Typography } from '@parkschannel/ui';
import classNames from 'classnames';

export interface TeamCardProps {
  src?: string;
  avatar?: React.ReactNode;
  name: string;
  position: string;
  text: string;
}

export const TeamCard: React.FC<TeamCardProps> = ({
  src,
  name,
  position,
  text,
  avatar,
}) => {
  return (
    <article className="w-full h-full bg-white drop-shadow p-4 rounded-2xl grid grid-cols-[min-content_1fr] gap-4 items-center md:gap-x-8 md:gap-y-3 md:p-6 md:items-start md:grid-rows-[min-content_1fr]">
      <div className="md:row-span-2">
        <CardAvatar size="xl" backgroundClassName="md:p-3 lg:p-4">
          {avatar || (
            <Avatar
              src={src}
              size={'xl'}
              className={classNames(
                'md:w-[136px] md:h-[136px] lg:w-[168px] lg:h-[168px] drop-shadow-xl'
              )}
            />
          )}
        </CardAvatar>
      </div>
      <div className="">
        <Typography
          variant="h4"
          component="h3"
          className="!text-lg mb-2 text-neutral-900"
        >
          {name}
        </Typography>

        <Tag value={position} size="sm" color="yellow" />
      </div>
      <p className="col-span-2 text-xs leading-[18px] text-neutral-600 md:col-start-2 md:col-end-2 md:col-auto ">
        {text}
      </p>
    </article>
  );
};
